require('console-polyfill');
require('./updated/babel-poly-init');
// some plugins still using globals...
var videojs = require('video.js');
window.videojs = videojs;
require('./legacy-dependencies');
require('./intlpoly');
